import { useState, useEffect, useRef, useCallback, Suspense } from "react";
import { connect } from "react-redux";
import Loading from "../../components/loading";
import DashboardTable from "./dashboardTable";
import Hero from "./hero";
import { getDashboard, setDefaultRedirection } from "../../actions/dashboard";
import AlertsCalendar from './alertsCalendar/alertsCalendar'
import { withRouter } from '../../helpers/withRouter';
import { updateUser } from "../../actions/session";
import DashboardTabs from "../../components/DashboardTabs";
import TaxHarvesting from "../taxHarvesting/TaxHarvesting";

const Dashboard = (props) => {
  const { language: lang } = props.match.internalization;

  const [loading, setLoading] = useState(true);
  const [lastMarketClose, setLastMarketClose] = useState({});
  const [introCards, setIntroCards] = useState([]);
  const [introCardsClients, setIntroCardsClients] = useState([]);
  const [pieHighChartData, setPieHighChartData] = useState([]);
  const [pieAssetClassData, setPieAssetClassData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [tooltips, setTooltips] = useState({});
  const [alerts, setAlerts] = useState({});
  const [showAlerts, setShowAlerts] = useState(false);
  const [dashboardTab, setDashboardTab] = useState("wealth");

  const fetchDashboard = useCallback(() => {
    props
      .getDashboard(props.authentication_token)
      .then((data) => successDashboard(data))
      .catch((err) => errorDashboard(err))
      .finally(() => finallyDashboard());
  }, [props.getDashboard, props.authentication_token]);


  useEffect(() => {
    console.log('blur_active', props.blur_active)
    if (props.blur_active){
      localStorage.setItem("isBlur", true) 
    }
    else{
      document.body.classList.remove("is-blur")
      document.body.classList.remove("blur-forced")
      

      localStorage.setItem("isBlur", false)
    }

  }, [])
  useEffect(() => {
    fetchDashboard();
    hideHeaderMenu();
    return () => hideHeaderMenu(true)
  }, [fetchDashboard]);

  // Hide burger menu items
  useEffect(() => {
    document.querySelector(".burger-menu").style.display = "block"
    const sidebarContainer = document.querySelector(".wrapper-sidebar .container")
    const sidebarItems = document.querySelector(".sidebar-items")
    sidebarContainer.style.justifyContent = "flex-start"
    sidebarItems.style.display = "none"
    return () => {
      sidebarContainer.style.justifyContent = "space-between"
      sidebarItems.style.display = "flex"
    } 
  }, [])

  // Create new configuation submenu
  useEffect(() => {
    const prefooter = document.querySelector(".sidebar-items.prefooter")
    const firstSeparator = prefooter.querySelector(".item-separator")

    // create new items
    let manuals_text = props.user.language === "en-US" ? "Manuals" : "Manuales"
    let profile_text = props.user.language === "en-US" ? "Profile" : "Perfil"
    let alerts_text = props.user.language === "en-US" ? "Alerts" : "Alertas"
    let demo_text = "Demo bt360 Pro"
    const divBlur = '<button class="wrapper-item blur-button"><p class="title1 item-text blur-text" style="padding-left: 24px;">Blur</p></button><div class="item-separator" style="width: 100%;"></div>'
    const divProfile = `<button class="wrapper-item profile-button"><p class="title1 item-text" style="padding-left: 24px;">${profile_text}</p></button><div class="item-separator" style="width: 100%;"></div>`
    const divManuals = `<button class="wrapper-item manuals-button"><p class="title1 item-text" style="padding-left: 24px;">${manuals_text}</p></button><div class="item-separator" style="width: 100%;"></div>`
    const divAlerts = `<button class="wrapper-item alerts-button"><p class="title1 item-text" style="padding-left: 24px;">${alerts_text}</p></button><div class="item-separator" style="width: 100%;"></div>`
    const divDemo = `<button class="wrapper-item demo-button"><p class="title1 item-text" style="padding-left: 24px;">${demo_text}</p></button><div class="item-separator" style="width: 100%;"></div>`
    const checkbox = `<div class="wrapper-item"><label class="container-check"><input ${props.user.pro_redirect_default ? 'checked' : ''} id="input-check" name="check" type="checkbox"><span class="checkmark"></span></label><div class="subwrapper-link-block"><span class="title1 item-text">Direct Access To John Doe</span></div></div><div class="item-separator" style="width: 100%;"></div>`    
    let array_to_join = [divBlur, divProfile, divManuals]

    if(props.user.admin){
      array_to_join = [checkbox, divBlur, divProfile, divManuals, divAlerts, divDemo]
    }
    const configSubmenuContainer = `<div class="config-submenu" style="width: 80%; margin-left: auto; margin-right: 10%;">${array_to_join.join('')}</div>`

    firstSeparator.insertAdjacentHTML('afterend', configSubmenuContainer)

    if(props.user.admin){
      document.querySelector('#input-check').addEventListener('click', inputChecked)
      document.querySelector(".alerts-button").addEventListener("click", goToAlerts);
      document.querySelector(".demo-button").addEventListener('click', handleDemo)      
    }
    
    document.querySelector(".blur-button").addEventListener('click', handleBlur)
    document.querySelector(".profile-button").addEventListener("click", goToProfile);
    document.querySelector(".manuals-button").addEventListener("click", goToManuals);

    document.querySelector(".prefooter.info-settings > button").style.pointerEvents = "none"

    return () => {
      document.querySelector(".blur-button") && document.querySelector(".blur-button").removeEventListener("click", handleBlur);
      document.querySelector(".profile-button") && document.querySelector(".profile-button").removeEventListener("click", goToProfile);
      document.querySelector(".manuals-button") && document.querySelector(".manuals-button").removeEventListener("click", goToManuals);
      document.querySelector(".manuals-button") && document.querySelector(".alerts-button").removeEventListener("click", goToAlerts);      
      document.querySelector(".config-submenu") && document.querySelector(".config-submenu").remove()
    };
  }, [])

  const handleDemo = () => {
    window.open("https://bulltick360.com/demo?auth_token=dLq8zSbTO_a4LOy0X0sgRA", "_blank");
  }
  const checkBlurActive = () => {
    const blurText = document.querySelector('.blur-text')
    const isBlur = localStorage.getItem("isBlur")
    if (isBlur === "true") {
      document.querySelector('.dashboard').classList.add("is-blur")
      blurText.innerHTML = 'Unblur'
    } 
  }

  const inputChecked = (e) => {
    console.log("inputChecked", props.user.pro_redirect_default)
    e.preventDefault();
    e.stopPropagation();
    props.setDefaultRedirection(props.authentication_token, !props.user.pro_redirect_default, () => window.location.reload(), () => alert("ko"))
  }
  const handleBlur = () => {
    const isBlur = localStorage.getItem("isBlur")
    if (isBlur === "false") {
      localStorage.setItem("isBlur", true)
    } else {
      localStorage.removeItem("isBlur")
    } 

    // Remove no-blur class from any element
    const itemWithNoBlur = document.querySelectorAll('.no-blur')
    itemWithNoBlur.forEach(item => item.classList.remove('no-blur'))

    const blurText = document.querySelector('.blur-text')
    if (blurText.innerHTML === 'Blur') {
      blurText.innerHTML = 'Unblur'
    } else {
      blurText.innerHTML = 'Blur'
    }

    document.body.classList.toggle("is-blur")

    let hash_prepared = { user: {blur_active: isBlur === "false" ? true : false} };
    props.updateUser(
      props.authentication_token,
      hash_prepared,
      () => {setLoading(true);window.location.reload()},
      (responseJSON) => ""
    );

  }

  const goToProfile = () => {
    window.location.href = "/pro/profile"
  }

  const goToManuals = () => {
    window.location.href = "/pro/profile?code=manuals"
  }

  const goToAlerts = () => {
    setShowAlerts(true)
    setTimeout(() => {
      document.getElementById("alerts_anchor").scrollIntoView({ behavior: "smooth" });
    }, 200)
  }
  const hideHeaderMenu = (leaving) => {
    const menu = document.querySelector(".c-header__content-bottom")
    if (menu) {
      if(leaving) {
        menu.style.display = "flex";
      } else {
        menu.style.display = "none";
      }  
    }
    
  }

  const successDashboard = (data) => {
    mappedData(data);
    props.getBreadcrumbs({
      assetUrl: "/pro",
      url: "/pro",
      assetTitle: "Dashboard",
    });
  };

  const errorDashboard = (error) => {
    window.location.href = '/'
  };

  const finallyDashboard = () => {
    setLoading(false);
  };

  const renderDashboardTabContent = (tab) => {
    if (tab === "wealth") {
      return (
        <>
          {tableData.length > 0 && (
            <DashboardTable
              data={tableData}
              headers={tableHeaders}
              history={props.history}
              location={props.location}
              lang={lang}
              tooltips={tooltips}
              demo={props.user.email === "demofamily@bulltick.com"}
            />
          )}
          {tableData.length > 0 && showAlerts && (
            <AlertsCalendar history={props.history} alerts={alerts} />
          )}
        </>
      );
    }

    if (tab === "tax-harvesting") {
      return <TaxHarvesting />;
    }

    if (tab === "tax-transaction") {
      return null;
    }

    return null;
  };

  const mappedData = (data) => {
    // Last market close
    setLastMarketClose(data.market_closed);

    // Intro cards
    setIntroCardsClients([
      { clients: data.clients },
      { actity_last_30_days: data.actity_last_30_days },
      { all_clients_registered: data.all_clients_registered }
    ]);
    setIntroCards([
      { total_aum: data.total_aum },
      { total_financial_aum: data.total_financial_aum },
      { average_size: data.average_size },
    ]);

    // Pie High Chart
    setPieHighChartData(data.pie_high_charts.data);
    setPieAssetClassData(data.pie_asset_class);

    // Table
    setTableHeaders(data.headers);
    setTableData(data.clients_table);

    // Tooltips
    setTooltips(data.clients_tooltips);
    // Alerts
    setAlerts(data.alerts)
  };

  useEffect(() => {
    if (tableData && tableData.length > 0) {
      setTimeout(() => {
        checkBlurActive()
      }, 120)
    }
  }, [tableData])

  if(loading) {
    return <Loading />
  }
  return (
    <div className="dashboard">
      <div className="main-wrapper market">

        <Hero 
          lastMarketClose={lastMarketClose}
          introCards={introCards}
          introCardsClients={introCardsClients}
          lang={lang}
          pieHighChartData={pieHighChartData}
          pieAssetClassData={pieAssetClassData}
        />

        <DashboardTabs
          tab={dashboardTab}
          onTabChange={(key) => setDashboardTab(key)}
          renderTabContent={renderDashboardTabContent}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    user: state.session.user,
    profile: state.session.profile,
    authentication_token: state.session.authentication_token,
    blur_active: state.session.blur_active    
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDashboard: (authentication_token, success, error) =>
      dispatch(getDashboard(authentication_token, success, error)),
    setDefaultRedirection: (authentication_token, success, error) =>
      dispatch(setDefaultRedirection(authentication_token, success, error)),
    updateUser: (authentication_token, attributes, success, error) =>
    dispatch(updateUser(authentication_token, attributes, success, error)),

  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));
